<script setup></script>

<template>
  <div class="text-center w-full flex items-center justify-center my-8 px-5 lg:px-20">
    <div class="max-w-7xl flex flex-col gap-8">
      <div class="flex flex-col gap-2">
        <p class="text-xs">{{ $t("post_footer_module.phrase_1") }}</p>
        <div class="flex justify-center items-center">
          <img class="max-h-[40px]" src="/img/footer/06_Harmonitzat_REact_EU-marca Next generation_SOC_correu.png"
            width="400" height="22" alt="" loading="lazy" />
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-xs">{{ $t("post_footer_module.phrase_2") }}</p>
        <div class="flex justify-center items-center">
          <img class="max-h-[40px] w-auto" src="/img/footer/programa-industrial-europeo.jpg" width="400" height="104"
            alt="" loading="lazy" />
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-xs">{{ $t("post_footer_module.phrase_3") }}</p>
        <div class="flex justify-center items-center">
          <img class="max-h-[40px] w-auto" src="/img/footer/accio.png" width="400" height="108" alt="" loading="lazy" />
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-xs">{{ $t("post_footer_module.phrase_4") }}</p>
        <p class="text-xs">{{ $t("post_footer_module.phrase_4_2") }}</p>
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-xs">{{ $t("post_footer_module.phrase_5") }}</p>
        <div class="flex justify-center items-center">
          <img class="max-h-[40px] w-auto" src="/img/footer/arc.jpg" width="400" height="55" alt="" loading="lazy" />
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-xs">{{ $t("post_footer_module.phrase_6") }}</p>
      </div>
      <div class="flex flex-col gap-2">
        <p class="text-xs">{{ $t("post_footer_module.phrase_7") }}</p>
        <p class="text-xs">{{ $t("post_footer_module.phrase_7_2") }}</p>
        <p class="text-xs">{{ $t("post_footer_module.phrase_7_3") }}</p>
        <div class="flex justify-center items-center">
          <img class="max-h-[40px] w-auto" src="/img/footer/det.jpg" width="400" height="101" alt="" loading="lazy" />
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <a href="https://www.accio.gencat.cat/etrade" target="_blank">
          <p class="text-xs">{{ $t("post_footer_module.phrase_8") }}</p>
        </a>
        <div class="flex justify-center items-center">
          <img class="max-h-[40px] w-auto" src="/img/footer/accio.png" width="400" height="108" alt="" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</template>
